<template>
    <div class="custom-fileuploader-template-wrapper">
        <div class="dx-fileuploader-files-container custom-fileuploader-files-container dx-widget" v-if="isCustomUploadMode()">
            <div class="dx-fileuploader-file-container custom-fileuploader-file-container" v-for="(file, index) in files">
                <div class="dx-fileuploader-button-container custom-fileuploader-button-container">
                    <div class="dx-fileuploader-button dx-fileuploader-cancel-button dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-icon" aria-label="close" tabindex="0" role="button" @click="removeFileFromList(index)">
                        <div class="dx-button-content">
                            <i class="dx-icon dx-icon-close"></i>
                        </div>
                    </div>
                </div>
                <div class="dx-fileuploader-file custom-fileuploader-file">
                    <div class="dx-fileuploader-file-info">
                        <div class="dx-fileuploader-file-name" style="max-width: 1074px;">{{ file.name }}</div>
                        <div class="dx-fileuploader-file-size">{{ formatFileSize(file.size) }}</div>
                    </div>
                    <div class="dx-fileuploader-file-status-message">Ready to upload</div>
                </div>
            </div>
        </div>
        <DxFileUploader :select-button-text="selectButtonText"
                        :label-text="labelText"
                        :accept="accept"
                        :multiple="multiple"
                        :upload-mode="uploadMode"
                        :min-file-size="minFileSize"
                        :max-file-size="maxFileSize"
                        :upload-url="uploadUrl"
                        :allowed-file-extensions="allowedFileExtensions"
                        :ref="fileUploaderRef"
                        :icon="icon"
                        :id="id"
                        @option-changed="_onOptionChanged"
                        @uploaded="onUploaded"
                        @value-changed="onValueChanged"
                        @upload-error="onUploadError"
                        :show-file-list="_showFileList()" />
    </div>
</template>
<script>
    import DxFileUploader from 'devextreme-vue/file-uploader';
 
    export default {
        name: 'CustomDxFileUploader',
        props: {
            selectButtonText: {
                default: 'Select file',
                type: String
            },
            labelText: {
                default: 'or Drop file here',
                type: String
            },
            accept: {
                default: '',
                type: String
            },
            multiple: {
                default: true,
                type: Boolean
            },
            uploadMode: {
                default: '',
                type: String
            },
            minFileSize: {
                default: 0,
                type: Number
            },
            maxFileSize: {
                default: 0,
                type: Number
            },
            uploadUrl: {
                default: '/',
                type: String
            },
            icon: {
                default: '',
                type: String
            },
            id: {
                default: 'cdfuid-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10),
                type: String
            },
            allowedFileExtensions: {
                default: () => [],
                type: Array
            },
            onOptionChanged: {
                default: (e) => {},
                type: Function
            },
            onUploaded: {
                default: (e) => {},
                type: Function
            },
            onValueChanged: {
                default: (e) => {},
                type: Function
            },
            onUploadError: {
                default: (e) => {},
                type: Function
            },
            showFileList: {
                default: true,
                type: Boolean
            }
        },
        components: {
            DxFileUploader
        },
        data() {
            let randRef = 'cdfu-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
            return {
                fileUploaderRef: randRef,
                files: []
            }
        },
        methods: {
            _onOptionChanged(e) {
                if (e.value.length) {
                    e.value.forEach((file) => {
                        this.readFile(file);
                        this.addFileToList(file);
                    });
                }
                return this.onOptionChanged(e);
            },
            _showFileList() {
                // Accepted Values: 'instantly' | 'useButtons' | 'useForm' 
                if (this.isCustomUploadMode()) {
                    return false;
                }
                return this.showFileList;
            },
            isCustomUploadMode() {
                return ['instantly', 'useButtons', 'useForm'].indexOf(this.uploadMode) == -1;
            },
            async readFile(file) {
                const reader = new FileReader();
                await reader.addEventListener('load', (event) => {
                    let src = event.target.result;
                    return src;
                });
                reader.readAsDataURL(file);
            },
            addFileToList(file) {
                let hasFile = this.files.some((elem) => {
                    if (
                        elem.name == file.name &&
                        elem.size == file.size &&
                        elem.type == file.type &&
                        elem.lastModified == file.lastModified
                    ) {
                        return true;
                    }
                    return false;
                });
                if (!hasFile) {
                    this.files.push(file);
                }
            },
            removeFileFromList(index) {
                this.files.splice(index, 1);
            },
            getFiles() {
                return this.files;
            },
            formatFileSize(bytes, si = false, dp = 1) {
                const thresh = si ? 1000 : 1024;

                if (Math.abs(bytes) < thresh) {
                    return bytes + ' B';
                }

                const units = si
                    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
                let u = -1;
                const r = 10 ** dp;

                do {
                    bytes /= thresh;
                    ++u;
                } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

                return bytes.toFixed(dp) + ' ' + units[u];
            },
            reset() {
                this.files = [];
                this.instance.reset();
            }
        },
        mounted() {
            if (this.icon.length > 0) {
                try {
                    let iconSpan = document.createElement('SPAN');
                    iconSpan.className = 'dx-icon dx-icon-' + this.icon;
                    let bc = document.querySelectorAll('#' + this.id + ' .dx-button-content');
                    let bt = document.querySelectorAll('#' + this.id + ' .dx-button-text');
                    bc[0].insertBefore(iconSpan, bt[0]);
                }
                catch (e) { }
            }
        },
        created() {
            ;
        },
        computed: {
            instance() {
                return this.$refs[this.fileUploaderRef].instance;
            }
        }
    }
</script>

<style>
    .custom-fileuploader-template-wrapper {

    }
</style>
<style scoped>
    /deep/ .dx-fileuploader-files-container {
        padding-top: 0;
        margin-top: -9px;
    }

    /deep/ .dx-fileuploader-input-wrapper {
        padding-top: 0;
    }

    /deep/ .dx-fileuploader-content {
        display: flex;
        flex-direction: column-reverse;
    }
</style>
